module.exports = __webpack_public_path__ + "assets/images/logo-720.93c84419.png";


//////////////////
// WEBPACK FOOTER
// ./imgs/logo-720.png
// module id = 155
// module chunks = 0